import React from "react";
import { Button } from "react-bootstrap";

import LandingPageContent from "./LandingPageContent";

// The optional first screen of the appointments flow (plan §17.6). Rendered only when
// the owner has turned it on, has written something, and the flow is not embedded in a
// widget — a widget is a few hundred pixels of a page that already supplies this
// context.
//
// Deep links skip it without any help from here: Appointments.tsx's URL effect
// overrides the initial step for every ?step= value, so confirmation, reschedule and
// cancellation emails land where they always did.

const LandingPageStep = ({ content, buttonStyle, onStart, background = "", ctaLabel = "Book now" }) => (
  <div
    className="appointments__step appointments__landing"
    // Custom properties rather than inline styles: the links are built by the markdown
    // renderer, and the CTA's backdrop is only needed at the mobile breakpoint where
    // it turns sticky, which is a media query's job rather than a prop's.
    style={
      {
        "--appointments-link-color": buttonStyle?.backgroundColor,
        "--appointments-page-background": background || "#fff"
      } as React.CSSProperties
    }
  >
    <LandingPageContent content={content} className="appointments__landing-content" />
    <div className="appointments__landing-cta">
      <Button className="appointments__landing-button" style={buttonStyle} type="button" onClick={onStart}>
        {ctaLabel}
      </Button>
    </div>
  </div>
);

export default LandingPageStep;
